import type { SizeUnit } from "../units";

export function getSizeUnitAbbreviation(unit: SizeUnit): string {
	switch (unit) {
		case "millimeters":
			return "mm";
		case "centimeters":
			return "cm";
		case "meters":
			return "m";
		case "kilometers":
			return "km";
	}
}
